import { env } from '~/utils/env';

export const getStripeKey = () => {
  return env.stripeKey;
};
